const currency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

export default function PerformanceExhibit({ exhibit }) {
  const showFacts = exhibit.format === "facts";
  const maximum = showFacts
    ? null
    : Math.max(...exhibit.rows.map(([, value]) => value));

  return (
    <figure className="rounded-2xl border border-blue-100 bg-blue-50/40 p-6 sm:p-8 lg:p-10">
      <figcaption>
        <p className="text-xs font-semibold uppercase tracking-widest text-vblue3">
          {exhibit.period}
        </p>
        <h2 className="mt-4 max-w-2xl text-2xl font-bold tracking-tight text-black sm:text-3xl">
          {exhibit.title}
        </h2>
        <p className="mt-3 text-sm text-black">{exhibit.unit}</p>
      </figcaption>
      <div
        className={
          showFacts
            ? `mt-8 grid gap-4 ${exhibit.rows.length === 3 ? "sm:grid-cols-3" : "sm:grid-cols-2 lg:grid-cols-4"}`
            : "mt-10 space-y-7"
        }
      >
        {exhibit.rows.map(([label, value]) => (
          <div key={label}>
            <dl
              className={
                showFacts
                  ? "h-full rounded-xl border border-blue-100 bg-white p-5"
                  : "flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1"
              }
            >
              <dt className="text-sm text-neutral-600">{label}</dt>
              <dd
                className={
                  showFacts
                    ? "mt-3 text-3xl font-semibold tabular-nums tracking-tight text-black"
                    : "text-lg font-semibold tabular-nums text-black sm:text-2xl"
                }
              >
                {showFacts ? value : currency.format(value)}
              </dd>
            </dl>
            {!showFacts && (
              <div
                aria-hidden="true"
                className="mt-3 h-3 overflow-hidden rounded-full bg-blue-100/60"
              >
                <div
                  className="h-full rounded-full bg-gradient-to-r from-vblue2 to-vcyan1"
                  style={{ width: `${(value / maximum) * 100}%` }}
                />
              </div>
            )}
          </div>
        ))}
      </div>
      <p className="mt-6 max-w-3xl text-xs leading-5 text-neutral-600">
        {exhibit.note}
      </p>
    </figure>
  );
}
